export enum ParkingAvailabilityCategory {
	ALL = 'All',
	VALET = 'Valet',
	DECK = 'Deck',
	NONE = 'none',
}
